import React from "react";
import PropTypes from "prop-types";
import { useSideNav } from "core/app/hooks/useSideNav";

const Logo = ({ width = "130", height = "50" }) => {
  const { theme } = useSideNav();
  const st0 = { fill: "#231f20" };
  const dark = { fill: "#000000" };
  const light = { fill: "#FFFFFF" };
  const themeStyle = theme === "light" ? dark : light;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 966.7 110.6"
      width={width}
      height={height}
      style={{ enableBackground: "0 0 966.7 110.6" }}
    >
      <g>
        <path
          style={st0}
          d="M226.7,94.8v15.8h-79.8V0h78.2v15.8h-60.9v29.2h48.2v15.8h-48.2v33.9h62.4Z"
        />
        <path
          style={st0}
          d="M289.1,0c15.4,0,28.6,5.5,39.6,16.4s16.5,23.9,16.5,39-5.5,28.1-16.5,39-24.2,16.4-39.6,16.4h-38.7V0h38.7ZM267.8,15.8v79h21.4c10.7,0,19.9-3.8,27.4-11.5s11.3-17,11.3-28-3.8-20.4-11.3-28-16.6-11.5-27.4-11.5h-21.4Z"
        />
        <path style={st0} d="M370.4,0h17.4v110.6h-17.4V0Z" />
        <path
          style={st0}
          d="M452.5,0h17.4l45.8,110.6h-18.1l-11.9-29.2h-49l-11.9,29.2h-18.1L452.5,0ZM443,65.6h36.3l-18.1-45.8-18.2,45.8Z"
        />
        <path
          style={st0}
          d="M714.8,0h17.4l45.8,110.6h-18.1l-11.9-29.2h-49l-11.9,29.2h-18.1L714.8,0ZM705.3,65.6h36.3l-18.1-45.8-18.2,45.8Z"
        />
        <path
          style={st0}
          d="M858.5,0v15.8h-33.2v94.8h-17.4V15.8h-33.2V0h83.7Z"
        />
        <path
          style={st0}
          d="M966.7,110.6h-17.4v-48.2h-54.5v48.2h-17.4V0h17.4v46.7h54.5V0h17.4v110.6Z"
        />
      </g>
      <g>
        <path
          style={st0}
          d="M0,0h15l42.7,53.8L100.3,0h15v110.6h-17.4V30.1l-40.3,50.5L0,8.3"
        />
        <g>
          <polygon
            style={st0}
            points="17.4 108.7 17.4 110.6 17.4 110.6 17.4 108.7"
          />
          <polygon
            style={st0}
            points="0 40.6 17.4 62.4 17.4 59.3 0 37.6 0 40.6"
          />
          <polygon
            style={st0}
            points="0 34.7 17.4 56.4 17.4 53.5 0 31.9 0 34.7"
          />
          <polygon
            style={st0}
            points="0 58.5 17.4 80.5 17.4 76.6 0 54.6 0 58.5"
          />
          <polygon
            style={st0}
            points="0 52.5 17.4 74.4 17.4 70.8 0 48.9 0 52.5"
          />
          <polygon
            style={st0}
            points="0 64.4 17.4 86.5 17.4 82.3 0 60.3 0 64.4"
          />
          <polygon
            style={st0}
            points="0 28.7 17.4 50.3 17.4 47.8 0 26.2 0 28.7"
          />
          <polygon
            style={st0}
            points="0 22.8 17.4 44.3 17.4 42.1 0 20.6 0 22.8"
          />
          <polygon
            style={st0}
            points="0 70.4 17.4 92.5 17.4 88 0 65.9 0 70.4"
          />
          <polygon style={st0} points="0 110.6 17 110.6 0 88.7 0 110.6" />
          <polygon
            style={st0}
            points="0 16.8 17.4 38.3 17.4 36.3 0 14.9 0 16.8"
          />
          <polygon
            style={st0}
            points="0 46.6 17.4 68.4 17.4 65.1 0 43.3 0 46.6"
          />
          <polygon
            style={st0}
            points="0 82.9 0 88.2 17.4 110.6 17.4 105.3 0 82.9"
          />
          <polygon
            style={st0}
            points="0 82.3 17.4 104.6 17.4 99.5 0 77.3 0 82.3"
          />
          <polygon
            style={st0}
            points="0 76.3 17.4 98.6 17.4 93.8 0 71.6 0 76.3"
          />
        </g>
      </g>
      <g style={themeStyle}>
        <path
          style={st0}
          d="M534.8,0h15l42.7,53.8L635.1,0h15v110.6h-17.4V30.1l-40.3,50.5-57.6-72.3"
        />
        <g>
          <polygon
            style={st0}
            points="552.1 108.7 552.1 110.6 552.1 110.6 552.1 108.7"
          />
          <polygon
            style={st0}
            points="534.7 40.6 552.1 62.4 552.1 59.3 534.7 37.6 534.7 40.6"
          />
          <polygon
            style={st0}
            points="534.7 34.7 552.1 56.4 552.1 53.5 534.7 31.9 534.7 34.7"
          />
          <polygon
            style={st0}
            points="534.7 58.5 552.1 80.5 552.1 76.6 534.7 54.6 534.7 58.5"
          />
          <polygon
            style={st0}
            points="534.7 52.5 552.1 74.4 552.1 70.8 534.7 48.9 534.7 52.5"
          />
          <polygon
            style={st0}
            points="534.7 64.4 552.1 86.5 552.1 82.3 534.7 60.3 534.7 64.4"
          />
          <polygon
            style={st0}
            points="534.7 28.7 552.1 50.3 552.1 47.8 534.7 26.2 534.7 28.7"
          />
          <polygon
            style={st0}
            points="534.7 22.8 552.1 44.3 552.1 42.1 534.7 20.6 534.7 22.8"
          />
          <polygon
            style={st0}
            points="534.7 70.4 552.1 92.5 552.1 88 534.7 65.9 534.7 70.4"
          />
          <polygon
            style={st0}
            points="534.7 110.6 551.7 110.6 534.7 88.7 534.7 110.6"
          />
          <polygon
            style={st0}
            points="534.7 16.8 552.1 38.3 552.1 36.3 534.7 14.9 534.7 16.8"
          />
          <polygon
            style={st0}
            points="534.7 46.6 552.1 68.4 552.1 65.1 534.7 43.3 534.7 46.6"
          />
          <polygon
            style={st0}
            points="534.7 82.9 534.7 88.2 552.1 110.6 552.1 105.3 534.7 82.9"
          />
          <polygon
            style={st0}
            points="534.7 82.3 552.1 104.6 552.1 99.5 534.7 77.3 534.7 82.3"
          />
          <polygon
            style={st0}
            points="534.7 76.3 552.1 98.6 552.1 93.8 534.7 71.6 534.7 76.3"
          />
        </g>
      </g>
    </svg>
  );
};

Logo.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

export default Logo;
